import { type ComponentProps, type FC } from "react";
import { Checkbox } from "@root/shared/components/Checkbox";
import * as styles from "./styles.css";

type Props = {
  text: string;
} & ComponentProps<typeof Checkbox>;

export const CheckboxAndText: FC<Props> = (props) => {
  const { text } = props;
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={styles.outer}>
      <Checkbox {...props} dataName={text} />
      <span className={styles.text}>{text}</span>
    </label>
  );
};
